import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c73d186"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar-header row items-center no-wrap q-py-sm q-px-md" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle1 text-weight-bold" }, "Faces", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_q_space),
    _createVNode(_component_q_btn, {
      size: "sm",
      icon: "fa fa-times",
      color: "grey",
      flat: "",
      round: "",
      dense: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
    })
  ]))
}